(function () {
  if (window.__zeusHoverVideoInit) {
    return;
  }

  window.__zeusHoverVideoInit = true;

  function canAutoplay() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    if (
      connection &&
      (connection.saveData || connection.effectiveType === "2g" || connection.effectiveType === "slow-2g")
    ) {
      return false;
    }

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return false;
    }

    return true;
  }

  function getVideo(card) {
    return card.querySelector("[data-zeus-hover-video-el]");
  }

  function playCard(card) {
    var video = getVideo(card);

    if (!video) {
      return;
    }

    video.preload = "auto";

    var playPromise = video.play();
    card.classList.add("is-playing");

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {
        card.classList.remove("is-playing");
      });
    }
  }

  function pauseCard(card) {
    var video = getVideo(card);

    if (!video) {
      return;
    }

    video.pause();
    video.currentTime = 0;
    card.classList.remove("is-playing");
  }

  function init() {
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-zeus-hover-video]"));

    if (!cards.length || !canAutoplay()) {
      return;
    }

    var hasFineHover = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    var hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    var tabletTouch =
      window.matchMedia && window.matchMedia("(min-width: 750px)").matches && navigator.maxTouchPoints > 0;

    if (hasFineHover) {
      cards.forEach(function (card) {
        card.addEventListener("pointerenter", function () {
          playCard(card);
        });

        card.addEventListener("pointerleave", function () {
          pauseCard(card);
        });
      });
    }

    if (hasTouch && !tabletTouch && "IntersectionObserver" in window) {
      var visibleCards = new Map();

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              visibleCards.set(entry.target, entry.intersectionRatio);
            } else {
              visibleCards.delete(entry.target);
              pauseCard(entry.target);
            }
          });

          var bestCard = null;
          var bestRatio = 0.5;

          visibleCards.forEach(function (ratio, card) {
            if (ratio >= bestRatio) {
              bestRatio = ratio;
              bestCard = card;
            }
          });

          cards.forEach(function (card) {
            if (card === bestCard) {
              playCard(card);
            } else {
              pauseCard(card);
            }
          });
        },
        { threshold: [0, 0.25, 0.5, 0.75, 1] },
      );

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
